export const POST_MESSAGE_TYPE = {
  READY_TO_CREATE_TRANSACTION: 'ready_to_create_transaction',
  CREATE_TRANSACTION: 'create_transaction',
  CREATE_TEST_TRANSACTION: 'create_test_transaction',
  CREATE_TRANSACTION_MOBILE_URL: 'create_transaction_mobile_url',
  CREATE_TRANSACTION_MOBILE_URL_RESULT: 'create_transaction_mobile_url_result',
  PAYMENT_RESULT: 'payment_result'
};

export const PAYMENT_STATUS = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};

export const CREATE_TRANSACTION_MOBILE_URL_STATUS = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};

export const POST_MESSAGE_CONTENT_MESSAGE = {
  USER_CANCEL: 'user_cancel',
  PAYMENT_ERROR: 'payment_error',
  PAYMENT_TIMEOUT: 'payment_timeout',
  PAYMENT_EXCEEDED_RETRY_LIMIT: 'exceeded_retry_limit',
  APP_UPDATE_REQUIRED: 'app_update_required'
};

export const TRANSACTION_STATUS = {
  CREATED: 'CREATED',
  REQUESTED: 'REQUESTED',
  CONFIRMED: 'CONFIRMED',
  RETRIEVED: 'RETRIEVED',
  CANCELED: 'CANCELED',
  TIMEOUT: 'TIMEOUT',
  ERRED: 'ERRED',
  EXPIRED: 'EXPIRED',
  APP_UPDATE_REQUIRED: 'APP_UPDATE_REQUIRED'
};

export const STATUS_TIME_LENGTH = {
  CANCEL: 5000,
  TIMEOUT: 5000,
  ERROR: 5000
};

export const POLLING_TIME = {
  EMAIL_POLL: 600,
  QR_POLL: 600,
  MOBILE_POLL: 600
};

export const MOBILE_ERROR_TYPE = {
  USER_CANCEL: 'USER_CANCEL',
  PAYMENT_TIMEOUT: 'PAYMENT_TIMEOUT',
  OTHER_ERRORS: 'OTHER_ERRORS',
  INTERNET_CONNECTION_FAILURE: 'INTERNET_CONNECTION_FAILURE',
  APP_UPDATE_REQUIRED: 'APP_UPDATE_REQUIRED'
};

export const MOBILE_ERROR_TYPE_TO_MESSAGE = {
  USER_CANCEL: 'pay.gsmpi.cancel.msg',
  PAYMENT_TIMEOUT: 'pay.gsmpi.error.timeout.msg',
  OTHER_ERRORS: 'pay.gsmpi.error.msg',
  INTERNET_CONNECTION_FAILURE: 'pay.gsmpi.connectionError'
};

export const MOBILE_INSTALL_TYPE = {
  INSTALL_APP: 'INSTALL_APP',
  UPDATE_APP: 'UPDATE_APP'
};

export const MOBILE_INSTALL_TYPE_TO_MESSAGE = {
  INSTALL_APP: 'pay.gmspi.mobile.installLatestVersion',
  UPDATE_APP: 'pay.gsmpi.app.update.msg'
};

export const MOBILE_INSTALL_TYPE_BUTTON = {
  INSTALL_APP: 'pay.gmspi.mobile.installButton',
  UPDATE_APP: 'pay.gsmpi.mobile.update.button'
};

export const MOBILE_URL_ERROR_TYPE = {
  DEFAULT_ERROR: 'MPI5N8001'
};

export const MOBILE_URL_ERROR_MESSAGE = {
  DEFAULT_ERROR: "An error occurred. Please try again later."
};

export const RSA = {
  PUBLIC_KEY: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2qm47k8UHYnSlZz5R1ZD/aZ7GEr5hf06MemIq842EAbqGEmMr+zh83PruWqLY/tOY+zr4ELd+YNc2ngcr0zgruV/RAL8m3L/BzV+Pv0uib0QPG2033IgKRoQDFEA5+GG6d9Q2+Cbeo5C6uY01VH+TkqxEp0K+Ml0b5BToERQxCJEkyizPmYPCN9AMzGODgMgFp5QiIk1VbXD2IVh66jl734CLBFfwv2D+1Dfd4QSmo95aIYXzKb1EdlGxqk9W0WqbX0Pb+AupfGn19HyXR7zbeVq1lPXEzabeH/9tzL9ghAqij6px9YF7iuOWjcCcE9jmsPolR+m96AJwSYueU48UwIDAQAB'
};

export const COOKIE = {
  KEY: "samsungPay"
};

export const PAYMENT_TABS = ['QR', 'EMAIL'];

export const TRANSACTION_FINAL_STATUS = [TRANSACTION_STATUS.CONFIRMED, TRANSACTION_STATUS.CANCELED, TRANSACTION_STATUS.EXPIRED, TRANSACTION_STATUS.ERRED, TRANSACTION_STATUS.APP_UPDATE_REQUIRED];
